import { Component, Inject, OnInit } from '@angular/core';
import { Invite } from '../../../../models/invite';
import { TeacherService } from '../../../../services/teacher.service';
import { GlobalVar } from '../../../../globals/global-var';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-read-invite',
  templateUrl: './read-invite.component.html',
  styleUrls: ['./read-invite.component.css']
})
export class ReadInviteComponent implements OnInit {

  invite: Invite = new Invite();

  a1: boolean;
  a2: boolean;
  a3: boolean;
  a4: boolean;

  b1: boolean;
  b2: boolean;
  b3: boolean;
  b4: boolean;
  b5: boolean;

  c1: boolean;
  c2: boolean;
  c3: boolean;
  c4: boolean;

  d1: boolean;
  d2: boolean;
  d3: boolean;
  d4: boolean;

  e1: boolean;
  e2: boolean;
  e3: boolean;


  timeOptionList = [
    { id: '008', value: '08點', click: false },
    { id: '009', value: '09點', click: false },
    { id: '010', value: '10點', click: false },
    { id: '011', value: '11點', click: false },
    { id: '012', value: '12點', click: false },
    { id: '013', value: '13點', click: false },
    { id: '014', value: '14點', click: false },
    { id: '015', value: '15點', click: false },
    { id: '016', value: '16點', click: false },
    { id: '017', value: '17點', click: false },
    { id: '018', value: '18點', click: false },
    { id: '019', value: '19點', click: false },
    { id: '020', value: '20點', click: false },
    { id: '021', value: '21點', click: false },
    //---
    { id: '108', value: '08點', click: false },
    { id: '109', value: '09點', click: false },
    { id: '110', value: '10點', click: false },
    { id: '111', value: '11點', click: false },
    { id: '112', value: '12點', click: false },
    { id: '113', value: '13點', click: false },
    { id: '114', value: '14點', click: false },
    { id: '115', value: '15點', click: false },
    { id: '116', value: '16點', click: false },
    { id: '117', value: '17點', click: false },
    { id: '118', value: '18點', click: false },
    { id: '119', value: '19點', click: false },
    { id: '120', value: '20點', click: false },
    { id: '121', value: '21點', click: false },
    //---
    { id: '208', value: '08點', click: false },
    { id: '209', value: '09點', click: false },
    { id: '210', value: '10點', click: false },
    { id: '211', value: '11點', click: false },
    { id: '212', value: '12點', click: false },
    { id: '213', value: '13點', click: false },
    { id: '214', value: '14點', click: false },
    { id: '215', value: '15點', click: false },
    { id: '216', value: '16點', click: false },
    { id: '217', value: '17點', click: false },
    { id: '218', value: '18點', click: false },
    { id: '219', value: '19點', click: false },
    { id: '220', value: '20點', click: false },
    { id: '221', value: '21點', click: false },
    //---
    { id: '308', value: '08點', click: false },
    { id: '309', value: '09點', click: false },
    { id: '310', value: '10點', click: false },
    { id: '311', value: '11點', click: false },
    { id: '312', value: '12點', click: false },
    { id: '313', value: '13點', click: false },
    { id: '314', value: '14點', click: false },
    { id: '315', value: '15點', click: false },
    { id: '316', value: '16點', click: false },
    { id: '317', value: '17點', click: false },
    { id: '318', value: '18點', click: false },
    { id: '319', value: '19點', click: false },
    { id: '320', value: '20點', click: false },
    { id: '321', value: '21點', click: false },
    //---
    { id: '408', value: '08點', click: false },
    { id: '409', value: '09點', click: false },
    { id: '410', value: '10點', click: false },
    { id: '411', value: '11點', click: false },
    { id: '412', value: '12點', click: false },
    { id: '413', value: '13點', click: false },
    { id: '414', value: '14點', click: false },
    { id: '415', value: '15點', click: false },
    { id: '416', value: '16點', click: false },
    { id: '417', value: '17點', click: false },
    { id: '418', value: '18點', click: false },
    { id: '419', value: '19點', click: false },
    { id: '420', value: '20點', click: false },
    { id: '421', value: '21點', click: false },
    //---
    { id: '508', value: '08點', click: false },
    { id: '509', value: '09點', click: false },
    { id: '510', value: '10點', click: false },
    { id: '511', value: '11點', click: false },
    { id: '512', value: '12點', click: false },
    { id: '513', value: '13點', click: false },
    { id: '514', value: '14點', click: false },
    { id: '515', value: '15點', click: false },
    { id: '516', value: '16點', click: false },
    { id: '517', value: '17點', click: false },
    { id: '518', value: '18點', click: false },
    { id: '519', value: '19點', click: false },
    { id: '520', value: '20點', click: false },
    { id: '521', value: '21點', click: false },
    //---
    { id: '608', value: '08點', click: false },
    { id: '609', value: '09點', click: false },
    { id: '610', value: '10點', click: false },
    { id: '611', value: '11點', click: false },
    { id: '612', value: '12點', click: false },
    { id: '613', value: '13點', click: false },
    { id: '614', value: '14點', click: false },
    { id: '615', value: '15點', click: false },
    { id: '616', value: '16點', click: false },
    { id: '617', value: '17點', click: false },
    { id: '618', value: '18點', click: false },
    { id: '619', value: '19點', click: false },
    { id: '620', value: '20點', click: false },
    { id: '621', value: '21點', click: false },
  ];
  constructor(private teacherService: TeacherService,
    public globalVar: GlobalVar,
    public dialogRef: MatDialogRef<ReadInviteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this.getInvite();
  }

  ngOnInit(): void {
  }

 
  getInvite() {
    this.teacherService.getInviteApi(this.data.invite.id).subscribe(
      result => {
        this.invite = result;
      },
      err => {
        alert(JSON.stringify(err.error))
      },
      () => {
        if (this.invite.timePoint != "") {
          let tempList = this.invite.timePoint.substring(0, this.invite.timePoint.length - 1).split(',');
          //console.log(tempList);
          for (let i = 0; i < tempList.length; i++) {
            for (let j = 0; j < this.timeOptionList.length; j++) {
              if (tempList[i] == this.timeOptionList[j].id) {
                this.timeOptionList[j].click = true;
              }
            }
          }
        }

        this.a1 = (this.invite.tool1.indexOf("a1") >= 0);
        this.a2 = (this.invite.tool1.indexOf("a2") >= 0);
        this.a3 = (this.invite.tool1.indexOf("a3") >= 0);
        this.a4 = (this.invite.tool1.indexOf("a4") >= 0);

        this.b1 = (this.invite.tool2.indexOf("b1") >= 0);
        this.b2 = (this.invite.tool2.indexOf("b2") >= 0);
        this.b3 = (this.invite.tool2.indexOf("b3") >= 0);
        this.b4 = (this.invite.tool2.indexOf("b4") >= 0);
        this.b5 = (this.invite.tool2.indexOf("b5") >= 0);

        this.c1 = (this.invite.serviceMethod.indexOf("c1") >= 0);
        this.c2 = (this.invite.serviceMethod.indexOf("c2") >= 0);
        this.c3 = (this.invite.serviceMethod.indexOf("c3") >= 0);
        this.c4 = (this.invite.serviceMethod.indexOf("c4") >= 0);

        this.d1 = (this.invite.teachMethod.indexOf("d1") >= 0);
        this.d2 = (this.invite.teachMethod.indexOf("d2") >= 0);
        this.d3 = (this.invite.teachMethod.indexOf("d3") >= 0);
        this.d4 = (this.invite.teachMethod.indexOf("d4") >= 0);

        this.e1 = (this.invite.teachingMaterial.indexOf("e1") >= 0);
        this.e2 = (this.invite.teachingMaterial.indexOf("e2") >= 0);
        this.e3 = (this.invite.teachingMaterial.indexOf("e3") >= 0);

      }
    );
  }

  //刪除會員
  deleteInvite() {
    if (confirm("確定刪除教師??") == true) {
      this.teacherService.deleteInviteApi(this.invite.id)
        .subscribe(
          result => {
            alert(result.message)
          },
          err => {
            alert(JSON.stringify(err.error))
          },
          () => {         
            this.dialogRef.close(this.invite.id);
          }
        );
    }
    else {
      return;
    }
  }

}
